import React, { Component, PropTypes } from 'react';
import Formsy from 'formsy-react';
import { autobind } from 'core-decorators';

import { passwordValidation } from 'utils/validationRules';
import { changePassword } from 'services/api';

import Modal, { ModalBody, ModalFooter } from 'AppComponents/Modal';
import { Input } from 'AppComponents/Forms/Formsy';
import Alert from 'AppComponents/Alert';


Formsy.addValidationRule('notEqualsField', (values, value, field) => value !== values[field]);

const mapInputs = (inputs) => {
  const newInputs = Object.assign({}, inputs);
  delete newInputs.new_password2;
  return newInputs;
};


class ChangePassword extends Component {

  static propTypes = {
    display: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    handleSuccess: PropTypes.func,
  };

  static defaultProps = {
    display: false,
    handleSuccess: () => {},
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableSubmit: false,
      isSubmitting: false,
      serverError: null,
    };
  }

  @autobind
  handleSubmit(data, resetForm, invalidateForm) {
    this.setState({ isSubmitting: true }, () => {
      changePassword(data).then(({ response, error }) => {
        if (error) {
          this.setState({ isSubmitting: false });
          if (typeof error === 'object') {
            this.setState({ serverError: error.detail });
            delete error.detail;
            const errors = {};
            Object.keys(error).forEach((field) => {
              errors[field] = error[field][0];
            });
            invalidateForm(errors);
          } else {
            this.setState({ serverError: 'An unknown error occurred. Please try again.' });
          }
        } else {
          this.props.handleSuccess({ username: response.username, password: data.new_password });
        }
      });
    });
  }

  render() {
    const { display, handleClose } = this.props;

    const { enableSubmit, isSubmitting, serverError } = this.state;

    return (
      <Modal
        title='Change Password'
        handleClose={handleClose}
        display={display}
      >

        <Formsy.Form
          onValid={() => this.setState({ enableSubmit: true })}
          onInvalid={() => this.setState({ enableSubmit: false })}
          onValidSubmit={this.handleSubmit}
          mapping={mapInputs}
          noValidate
        >

          <ModalBody>

            <Alert type='danger' display={!!serverError}>
              <strong>Error: </strong>{ serverError }
            </Alert>

            <Input
              type='password'
              name='old_password'
              label='Current Password'
              required
            />

            <Input
              type='password'
              name='new_password'
              label='New Password'
              validations={Object.assign({}, passwordValidation.validations, {
                notEqualsField: 'old_password',
              })}
              validationErrors={Object.assign({}, passwordValidation.validationErrors, {
                notEqualsField: 'New password cannot be the same as the current password.',
              })}
              required
            />

            <Input
              type='password'
              name='new_password2'
              label='Confirm New Password'
              validations={{
                equalsField: 'new_password',
              }}
              validationErrors={{
                equalsField: 'Passwords must match.',
              }}
              required
            />

          </ModalBody>

          <ModalFooter
            submitButtonEnabled={enableSubmit}
            isSubmitting={isSubmitting}
          />

        </Formsy.Form>

      </Modal>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/UserAccount/ChangePassword/index.jsx